import React, { Component } from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';

class DuplicatePageModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: `${props.page.title} - Copy`,
			submitting: false
		};
	}

	submit = () => {
		this.setState({ submitting: true });
		this.props.duplicatePage(this.props.page, () => {
			this.setState({ submitting: false });
			this.props.toggle();
		});
	};

	render() {
		const { isOpen, toggle, page } = this.props;
		const { name, submitting } = this.state;

		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				toggle={toggle}
				modalTitle="Duplicate Page Template"
				bodyContent={() => (
					<div>
						<InputField
							label="Page Name"
							value={name}
							onChange={(e) => this.setState({ name: e.target.value })}
							required={true}
						/>
					</div>
				)}
				actionButtonLabel={submitting ? 'Duplicating...' : 'Duplicate Page'}
				actionButton={() => this.submit()}
				actionButtonDisabled={submitting || !name.trim()}
			/>
		);
	}
}

export default DuplicatePageModal;